let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("klnez")).then(() => parcelRequire('4es1M'));